<template>
  <div>
    <v-overlay :absolute="true" :value="isMenuExpanded" :z-index="6" :opacity="0.7"></v-overlay>
    <v-speed-dial
      v-model="isMenuExpanded"
      style="position:absolute;right:8px;top:-18px;z-index: 7;"
      direction="bottom"
    >
      <template v-slot:activator>
        <v-btn v-model="isMenuExpanded" small color="white" fab>
          <v-icon v-if="isMenuExpanded">mdi-close</v-icon>
          <v-icon v-else>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-btn fab small color="white" class="mt-1 mb-1" :disabled="first" @click="moveInfoPairUp">
        <v-icon>mdi-arrow-up-bold</v-icon>
      </v-btn>

      <v-btn fab small color="white" class="mt-1 mb-1" :disabled="last" @click="moveInfoPairDown">
        <v-icon>mdi-arrow-down-bold</v-icon>
      </v-btn>

      <v-btn fab small color="white" class="mt-1 mb-1" @click="deleteInfoPair">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-speed-dial>
  </div>
</template>

<script>
export default {
  props: {
    first: {
      type: Boolean,
      default: false
    },
    last: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isMenuExpanded: false
    }
  },
  methods: {
    deleteInfoPair() {
      this.$emit('delete_infopair')
    },
    moveInfoPairUp() {
      this.$emit('move_infopair_up')
    },
    moveInfoPairDown() {
      this.$emit('move_infopair_down')
    }
  }
}
</script>

<style></style>
